import { useRecordLoader } from "./useRecordLoader";
import { useInitialQueryLimit } from "./useInitialQueryLimit";
import { observeFilteredThreadEntriesForVirtualList } from "~/components/content-list/ThreadEntry";

export function useRequestViewThreads(props: { filterBy: "received" | "sent" }) {
  const initialLimit = useInitialQueryLimit(100);

  return useRecordLoader({
    name: "useRequestNotifications",
    load({ loader, limit, currentUserId, deps: [filterBy] }) {
      const observable = loader.observeGetRequestViewThreads({
        senderUserId: filterBy === "sent" ? currentUserId : undefined,
        recipientUserId: filterBy === "received" ? currentUserId : undefined,
        limit,
      });

      return observeFilteredThreadEntriesForVirtualList({ recordLoader: loader }, observable);
    },
    initialLimit,
    limitStep: initialLimit,
    deps: [props.filterBy],
  });
}
